import React from 'react';
import { make2DigitNumber } from "../../../join-commute/helpers/commonHelper";

export default function DateSection({dayData, month}) {
    return (
        <div className='date-section' aria-label={`${dayData.todayDate} ${month} ${dayData.day} ${dayData.isPresentDay ? 'today' : ''}`}>
            <div className={dayData.isPresentDay ? 'day today' : 'day'}>{make2DigitNumber(dayData.todayDate)}</div>
            {dayData.isPresentDay ? <div className='weekday'>Today</div> : <div className='weekday'>{dayData.day.substr(0, 3)}</div>}
        </div>
    )
}